export default "__VITE_ASSET__ebec1b40__"